// removed by extract-text-webpack-plugin
module.exports = {"container":"container-1QoxH container-1LaSk container-3-GEX input-2t6DG label-Y5lvX","input":"input-3zSMD","iconContainer":"iconContainer-33F56 iconContainer-3gJGn","icon":"icon-Kim48 icon-278NI","selected":"selected-3n1f0 selected-3TCgY","disabled":"disabled-8PU2X disabled-1MPgS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/CheckboxField/_checkboxSwitch.css
// module id = 1188
// module chunks = 1